import { inject, Injectable } from "@angular/core";
import { Http } from "@skylab-angular-shared/core";
import { HttpService, TaggedUrl, Tags } from "@skylab-shared/core";
import { HttpStatusCode } from "axios";

export type KsefCertificateUploadItem = {
	certificateFile: File;
	privateKeyFile: File;
	privateKeyPassword: string;
}

export type KsefCertificateItem = {
	serialNumber: string;
}

export enum KsefCertificateUploadErrorMessages {
	CERT_IS_NOT_OFFLINE = "CERT_IS_NOT_OFFLINE",
	INVALID_PRIVATE_KEY = "INVALID_PRIVATE_KEY",
	UNSUPPORTED_PRIVATE_KEY_FORMAT = "UNSUPPORTED_PRIVATE_KEY_FORMAT",
	CERT_FORMAT_INCORRECT = "CERT_FORMAT_INCORRECT",
	KEY_DOES_NOT_MATCH_CERT = "KEY_DOES_NOT_MATCH_CERT",
	INCORRECT_PRIVATE_KEY_PASSWORD = "INCORRECT_PRIVATE_KEY_PASSWORD",
}

@Injectable({providedIn: 'root'})
export class KsefCertificateService {
	private readonly http = inject(Http) as HttpService;
	private readonly URL = TaggedUrl.join('ksef/certificate', [Tags.Api]);

	public async uploadCertificateAsync(data: KsefCertificateUploadItem): Promise<void> {
		const formData = new FormData();

		formData.append('CertificateFile', data.certificateFile);
		formData.append('PrivateKeyFile', data.privateKeyFile);
		formData.append('PrivateKeyPassword', data.privateKeyPassword);

		await this.http.post(this.URL, formData, { transformRequest: [] });
	}

	public async getCertificateAsync(): Promise<KsefCertificateItem[]> {
		const response = await this.http.get<KsefCertificateItem>(this.URL, {
			validateStatus: status => status === HttpStatusCode.Ok || status === HttpStatusCode.NotFound
		});

		if (response.status === HttpStatusCode.Ok) return [response.data];
		return [];
	}

	public async deleteCertificateAsync(): Promise<void> {
		await this.http.delete(this.URL);
	}
}